// src/components/ProximityModal.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ProximityModal.css';

export default function ProximityModal({ isOpen, onClose, spotInfo, onModalClick }) {
  const { t } = useTranslation();
  if (!isOpen || !spotInfo) return null;

  // Stamp 用の固定アイコン画像（必要に応じて差し替え）
  const STAMP_BADGE_SRC = '/images/stamp.png';

  // オーバーレイは閉じない（誤タップ防止）
  const handleOverlayClick = (e) => {
    e.stopPropagation();
  };

  // モーダル本体クリックでスポット詳細へ
  const handleModalClick = () => {
    onModalClick?.(spotInfo.id);
  };

  const spotData = {
    image: spotInfo.image || spotInfo.thumbnail || '/images/default-spot.jpg',
    title: spotInfo.title || spotInfo.name || t('proximity.defaultTitle', 'スポット'),
    description: spotInfo.description || t('proximity.defaultDescription', 'スポット情報'),
    category: spotInfo.category,
    icon: spotInfo.icon, // 既存のiconも保持
  };

  // Stamp 判定：category が 'Stamp' または 既存の絵文字が 🏆
  const isStamp = spotData.category === 'Stamp' || spotData.icon === '🏆';

  return (
    <div className="proximity-modal-overlay" onClick={handleOverlayClick}>
      <div className="proximity-modal" onClick={handleModalClick}>
        <button
          className="proximity-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}
          aria-label={t('map.buttons.close', '閉じる')}
          title={t('map.buttons.close', '閉じる')}
        >
          ✕
        </button>

        <div className="proximity-content">
          <div className="proximity-image-container" aria-hidden>
            <img
              src={spotData.image}
              alt={spotData.title}
              className="proximity-image"
              onError={(e) => {
                e.currentTarget.src = '/images/default-spot.jpg';
              }}
            />
          </div>

          <div className="proximity-info">
            <div className="proximity-header">
              {/* タイトルの右にバッジを置く */}
              <h3
                className="proximity-title"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 10, // タイトルとアイコンの間隔
                }}
              >
                <span>{spotData.title}</span>
                {isStamp && (
                  <img
                    src={STAMP_BADGE_SRC}
                    alt=""
                    aria-hidden
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      // 既存デザインに合わせた外枠っぽい表現
                      boxShadow: '0 0 0 2px #fff, 0 1px 4px rgba(0,0,0,0.2)',
                    }}
                    onError={(e) => {
                      e.currentTarget.style.background = '#e5e7eb';
                      e.currentTarget.src = '/images/default-spot.jpg';
                    }}
                  />
                )}
              </h3>
            </div>

            <p className="proximity-description">{spotData.description}</p>

            <div className="proximity-action-hint">
              <span>{t('proximity.tapToOpen', 'タップして詳細を表示')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
